import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { PureComponent } from 'react';
import update from 'immutability-helper';
import { createSelector } from 'reselect';
import _isEmpty from 'lodash/isEmpty';
import _property from 'lodash/property';
import { getFieldIds } from '../utils/general';
function getUpdateConfig(unit) {
  if (typeof unit === 'string') {
    return {};
  }
  var childConfig = (unit.rows || unit.columns).reduce(function (conf, unitItem, index) {
    var updConf = getUpdateConfig(unitItem);
    if (!_isEmpty(updConf)) {
      conf[unit.rows ? 'rows' : 'columns'] = _defineProperty({}, index, updConf); // eslint-disable-line
    }

    return conf;
  }, {});
  return _objectSpread({
    fieldIds: {
      $set: getFieldIds(unit)
    }
  }, childConfig);
}
export function getInsertedFieldIdsSection(sections) {
  return sections.reduce(function (result, layout) {
    var updConf = getUpdateConfig(layout);
    result.push(update(layout, updConf));
    return result;
  }, []);
}
function createInsertedFieldIdsSection() {
  return createSelector(_property('sections'), getInsertedFieldIdsSection);
}
export default function wrapProcessedFieldGroups(ComposedComponent) {
  return /*#__PURE__*/function (_PureComponent) {
    _inherits(withProcessedFieldGroups, _PureComponent);
    var _super = _createSuper(withProcessedFieldGroups);
    function withProcessedFieldGroups(props) {
      var _this;
      _classCallCheck(this, withProcessedFieldGroups);
      _this = _super.call(this, props);
      _this.layoutsGenerator = createInsertedFieldIdsSection();
      return _this;
    }
    _createClass(withProcessedFieldGroups, [{
      key: "render",
      value: function render() {
        var props = this.props;
        return /*#__PURE__*/React.createElement(ComposedComponent, _extends({}, props, {
          sections: this.layoutsGenerator(props)
        }));
      }
    }]);
    return withProcessedFieldGroups;
  }(PureComponent);
}